import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '24px',
    border: '1px solid #0000001A',
    alignItems: 'center',
    borderRadius: '16px',
    textDecoration: 'none',
    color: 'inherit',
  },
  image: {
    width: '106px',
    height: '106px',
  },
  title: {
    textAlign: 'center',
  },
  description: {
    textAlign: 'center',
  },
  actionButton: {
    fontSize: '12px',
    marginTop: '-12px',
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
